var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrScannedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.9963C0 5.37093 5.37093 0 11.9963 0C18.6217 0 23.9926 5.37093 23.9926 11.9963C23.9926 18.6217 18.6217 23.9926 11.9963 23.9926C5.37093 23.9926 0 18.6217 0 11.9963Z",
    fill: "#0B5ED7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10004_274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9876 18.6561C15.6657 18.6561 18.6475 15.6743 18.6475 11.9962C18.6475 8.31808 15.6657 5.33636 11.9876 5.33636C8.30947 5.33636 5.32776 8.31808 5.32776 11.9962C5.32776 15.6743 8.30947 18.6561 11.9876 18.6561Z",
    stroke: "white",
    strokeWidth: 1.99795,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98975 11.9962L11.3217 13.3282L13.9857 10.6642",
    stroke: "white",
    strokeWidth: 1.99795,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10004_274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9836,
    height: 15.9836,
    fill: "white",
    transform: "translate(3.99585 4.00439)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrScannedIcon);
export default __webpack_public_path__ + "static/media/qr_scanned_icon.a9d524c48c30d08fc3125fb04d0b12a8.svg";
export { ForwardRef as ReactComponent };